// extracted by mini-css-extract-plugin
module.exports = {"logo_banner":"LogoBanner_logo_banner__6dYSi","logo_wrapper":"LogoBanner_logo_wrapper__5hxWh","logo_limit":"LogoBanner_logo_limit__4W6jm"};